import { getJobList } from './GetJobList';
import { getRecommendedRates } from './GetRecommendedRates';

/**
 * Jobs API Client
 * Provides low-level HTTP calls to jobs endpoints
 */
export const JobsApi = {
  getJobList,
  getRecommendedRates,
};
